"use strict";

var _classCallCheck = require("/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deferred = void 0;
var Deferred = function Deferred() {
  var _this = this;
  _classCallCheck(this, Deferred);
  this.resolve = function () {
    return null;
  };
  this.reject = function () {
    return null;
  };
  this.promise = new Promise(function (resolve, reject) {
    _this.reject = reject;
    _this.resolve = resolve;
  });
};
exports.Deferred = Deferred;